var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { usePopper } from "react-popper";
import { IToolbarButtonActiveContentType } from "../../types";
/**
 * Internal component used to render a menu.
 * This component is used by the ToolbarButtonStateful component to render active content that is either a dropdown or a horizontal menu.
 */
export var ToolbarButtonMenu = function (props) {
    var activeStateContentType = props.activeStateContentType, children = props.children, open = props.open, setMenuReferenceElement = props.setMenuReferenceElement, menuReferenceElement = props.menuReferenceElement, menuProps = __rest(props, ["activeStateContentType", "children", "open", "setMenuReferenceElement", "menuReferenceElement"]);
    var _a = usePopper(menuProps.anchorEl, menuReferenceElement, {
        placement: "bottom",
    }), styles = _a.styles, attributes = _a.attributes;
    if (!open) {
        return null;
    }
    if (activeStateContentType === IToolbarButtonActiveContentType.DROPDOWN) {
        return (_jsx("ul", __assign({ tabIndex: -1, className: "dropdown", style: styles.popper }, attributes.popper, { ref: setMenuReferenceElement, role: "menu" }, { children: children })));
    }
    else {
        return (_jsx("ul", __assign({ tabIndex: -1, className: "horizontal-menu", style: styles.popper }, attributes.popper, { ref: setMenuReferenceElement, role: "menu" }, { children: children })));
    }
};
